import { render, staticRenderFns } from "./TabelaDadosFinanceirosPf.vue?vue&type=template&id=f993c864&lang=pug"
import script from "./TabelaDadosFinanceirosPf.vue?vue&type=script&lang=js"
export * from "./TabelaDadosFinanceirosPf.vue?vue&type=script&lang=js"
import style0 from "./TabelaDadosFinanceirosPf.vue?vue&type=style&index=0&id=f993c864&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports